import { render, staticRenderFns } from "./remarksModal.vue?vue&type=template&id=044d10a2&scoped=true&"
import script from "./remarksModal.vue?vue&type=script&lang=js&"
export * from "./remarksModal.vue?vue&type=script&lang=js&"
import style0 from "./remarksModal.vue?vue&type=style&index=0&id=044d10a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044d10a2",
  null
  
)

export default component.exports